<template>
   <div>
    <loading :status="loading"></loading>
        <div >
          <qr-code :size="100" :text="`${currentUrl}/track/${repair.tracking}`"></qr-code>
          <h4 class="text-1 font-bold py-2 tracking-wider uppercase"> {{ $t('Invoice') }} #{{ repair.tracking }} </h4>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Invoice date') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.created_at }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Brand') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.brand }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Name') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.device.name }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Model') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.device.model }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Serial number') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.serial_number }}</div>
          </div>
        </div>
        <div class="flex justify-between my-2">
          <div class="w-full pt-2">
            <label class="block mb-1 font-bold text-xl uppercase tracking-wide">{{ $t('From') }}:</label>
            <div class="text-sm">
              <div>
                <strong>{{ $t('Name') }}:</strong>
                {{ repair.name | capitalize }}
              </div>
              <div>
                <strong>{{ $t('Email') }}:</strong>
                {{ repair.email }}
              </div>
              <div>
                <strong>{{ $t('Phone') }}:</strong>
                {{ repair.phone }}
              </div>
              <div>
                <strong>{{ $t('Address') }}:</strong>
                {{ repair.address }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            mt-2
            flex flex-wrap
            py-2
            items-start
          "
        >
          <div class="mb-1">
            <label class="block mb-1 font-bold text-xl uppercase tracking-wide">{{ $t('Dispatched To') }}:</label>
            <h2 class="text-3xl font-bold pb-2 tracking-wider uppercase">
              {{ $store.state.settings.name }}
              <small class="text-sm">
                <p>{{ $store.state.settings.phone }}</p>
                <p>{{ $store.state.settings.address }}</p>
              </small>
            </h2>
          </div>
        </div>
      </div>
</template>
<script>
import VueQRCodeComponent from 'vue-qrcode-component';
export default {
  name: 'dispatch-info',
  metaInfo() {
    return {
      titleTemplate: this.$store.state.settings.name,
    };
  },
  components: { 'qr-code': VueQRCodeComponent },
  data() {
    return {
      loading: false,
      currentUrl: window.app.url,
      repair: {
        device: {
          model: null,
          name: null,
        },
        defects: [],
        priority: {},
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
          this.loading = true;
      axios
        .get(route('repair-dispatch.print', this.$route.params.id))
        .then((response) => {
          this.repair = response.data.repair;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
